import type {RouteRecordRaw} from "vue-router";

export const routeName = 'CabinetPermissions';
export const employeeRouteName = 'CabinetPermissionsEmployee';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'permissions',
    component: () => import('@/pages/Permissions'),
    meta: {
        isHide: true,
    }
};

export const employeeRoute: RouteRecordRaw = {
    name: employeeRouteName,
    path: 'permissions/:userId',
    component: () => import('@/pages/Permissions/ui/EmployeePermissions.vue'),
    props: true,
    meta: {
        isHide: true,
    }
};
